import { css } from '@emotion/react'

const customAvatarContainer = css`
  display: inline-block;
  height: 32px;
  width: 32px;
  position: relative;
`

const avatar = css`
  display: flex;
  align-items: center;
  background: var(--color-monochrome-white);
  border: none;
  border-radius: 50%;
  vertical-align: top;
  overflow: hidden;
  height: 100%;
  width: 100%;
  margin-top: 20px;

  > svg {
    margin: 0 auto;
  }
`

export const styles = {
  customAvatarContainer,
  avatar,
}
